module.exports = __webpack_public_path__ + "img/menu-icon.5e257ae0.svg";